import { AllDataUser } from '../../../all-data-user/all-data-user';
import { UserData } from '../../user-data';

/**
 * Return the display name associated to a given userId.
 * @param userDataMap Map giving userData associated to each userId
 * @param userId Return display name of this user
 */
export const getUserDisplayNameByUserId = (
  userDataMap: Map<string, UserData | AllDataUser>,
  userId: string | undefined,
): string => {
  if (userId === undefined) {
    return '';
  }

  const userData = userDataMap.get(userId);

  if (userData instanceof UserData) {
    return userData.getDisplayNameWithEmail();
  }

  if (userData instanceof AllDataUser) {
    return userData.userData.getDisplayNameWithEmail();
  }

  return `Deleted User: ${userId}`;
};
